import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-4 whitespace-nowrap">
              APP下载
            </span>
            <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {appData.description}
            </p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
              {appData.features.map((feat, i) => (
                <li key={i} className="flex items-center gap-2 text-sm text-foreground-700">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-accent-500 text-base"></i>
                  </span>
                  {feat}
                </li>
              ))}
            </ul>
            <div className="flex flex-wrap gap-3">
              <a href="#" className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-white text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i>
                iOS 下载
              </a>
              <a href="#" className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-white text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[380px] aspect-[4/5] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20manga%20comic%20reading%20app%20interface%20with%20beautiful%20illustrated%20comic%20panels%2C%20clean%20modern%20mobile%20UI%20design%20in%20warm%20amber%20and%20soft%20cream%20colors%2C%20digital%20reading%20app%20concept%2C%20minimal%20product%20presentation%2C%20soft%20studio%20lighting&width=760&height=950&seq=app-mockup-manga&orientation=portrait"
                alt="43423漫画网APP下载"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}